import { useCallback } from 'react';
import { invariant } from 'ts-invariant';
import type { OnActionArgs } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import useControlBlockMethod from '../controlBlockMethod/useControlBlockMethod';

type FormActionPayload = {
  formId?: string;
};

function useFormActions() {
  const { onCallBlockMethod } = useControlBlockMethod();

  const onSubmitForm = useCallback(
    async ({ action, actionContext, instanceId }: OnActionArgs) => {
      const payload = action.payload as FormActionPayload;
      const blockId = payload.formId;
      invariant(blockId, 'Form id is required');
      await onCallBlockMethod({
        blockId,
        methodName: 'submitForm',
        action,
        actionContext,
        instanceId,
      });
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [onCallBlockMethod],
  );

  return { onSubmitForm };
}

export default useFormActions;
